import * as ActionTypes from '../actions/FinalizeSocialPayActions';
import * as SocialPayActionTypes from '../actions/SocialPayActions';
import Providers from '../constants/SocialPayConstants';
import { objectWithout } from 'config/utils';

const initialState = {
  isFormValidated: false,
  isFormSubmitted: false,
  selectedSocialPayPlatform: null,
  [Providers.TWITTER]: {
    message: '',
    screenName: '',
    errors: {},
  },
};

export function finalizeSocialPay (state = initialState, action) {
  switch (action.type) {
    case SocialPayActionTypes.HANDLE_SOCIALPAY_AUTH_CALLBACK: {
      const { socialPayCallbackData, socialPayCallbackData: { provider } } = action.payload;
      return {
        ...state,
        selectedSocialPayPlatform: provider,
        [provider]: {
          ...state[provider],
          ...socialPayCallbackData,
        },
      };

    }

    case ActionTypes.HANDLE_CHANGE_SOCIAL_PAY_INPUT: {
      const { changedProps, provider } = action.payload;
      return {
        ...state,
        [provider]: {
          ...state[provider],
          ...changedProps,
          errors: objectWithout(state[provider].errors, Object.keys(changedProps)[0]),
        },
      };
    }

    case ActionTypes.HANDLE_SOCIAL_PAY_SUCCESS: {
      return {
        ...state,
        isFormSubmitted: true,
        isFormValidated: true,
      };
    }

    case ActionTypes.HANDLE_SOCIAL_PAY_FAILURE: {
      const { errors } = action;
      const { selectedSocialPayPlatform } = state;
      return {
        ...state,
        [selectedSocialPayPlatform]: {
          ...state[selectedSocialPayPlatform],
          errors: {
            ...state[selectedSocialPayPlatform].errors,
            ...errors,
          },
        },
      };
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/payments/reducers/FinalizeSocialPayReducers.js